import * as LayoutCreatorEntities from '@bimser/components/dist/BCLayoutCreator/common/entities';
import { FormItemTypes } from '@bimser/core';
import { Map } from 'immutable';
import { IVariableItem } from '../../../entities/common';

export function getFormulaFactKeys(
	data: Map<string, LayoutCreatorEntities.LayoutItem>,
	factKey: string
): string[] {
	const factArr = factKey.split('.');
	const controlId = factArr.shift();
	const returnFactKeys: string[] = [];

	const control = data.get(controlId);
	if (control && control.type === FormItemTypes.EContainerTypes.Form) {
		if (factArr.indexOf('variables') === 0) {
			const variable: IVariableItem = control.properties.getIn(factArr);

			const controlRegex = /\[([\s\S]*?)\]/gm;
			const match = variable.value.match(controlRegex);

			if (match) {
				match.forEach(source => {
					const rawPath = source.replace('[', '').replace(']', '').split('.');
					returnFactKeys.push(rawPath.join('.'));
				});
			}
		}
	}

	return returnFactKeys;
}
